import { render, staticRenderFns } from "./RequirementsEditor.vue?vue&type=template&id=9a0c0f28&scoped=true&"
import script from "./RequirementsEditor.vue?vue&type=script&lang=js&"
export * from "./RequirementsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0c0f28",
  null
  
)

export default component.exports